import { createAction } from '@reduxjs/toolkit';

import {
  LOG_IN,
  LOG_OUT,
  SIGN_UP,
  CONFIRM_CLIENT,
  SHOW_AUTH_POPUP,
  HIDE_AUTH_POPUP,
  SHOW_LOGOUT_POPUP,
  HIDE_LOGOUT_POPUP,
  ON_LOAD,
  FETCH_CLIENT_INFO,
  SET_CLIENT_INFO,
  SET_CLIENT_AUTH_TOKEN,
  SET_CLIENT_CONFIRM_PHONE,
  SET_CLIENT_BONUS_SCORE,
} from './constants';

export const logInAction = (payload) => ({
  type: LOG_IN,
  payload,
});

export const logOutAction = () => ({
  type: LOG_OUT,
});

export const signUpAction = (payload) => ({
  type: SIGN_UP,
  payload,
});

export const confirmClientAction = createAction<boolean | null>(CONFIRM_CLIENT);

export const showAuthAction = () => ({
  type: SHOW_AUTH_POPUP,
});

export const hideAuthAction = () => ({
  type: HIDE_AUTH_POPUP,
});

export const showLogOutAction = () => ({
  type: SHOW_LOGOUT_POPUP,
});

export const hideLogOutAction = () => ({
  type: HIDE_LOGOUT_POPUP,
});

export const onLoadAction = () => ({
  type: ON_LOAD,
});
export const setClientConfirmPhone = (payload) => ({
  type: SET_CLIENT_CONFIRM_PHONE,
  payload,
});

export const setClientInfo = createAction<any>(SET_CLIENT_INFO);
export const setClientAuthToken = createAction<any>(SET_CLIENT_AUTH_TOKEN);
export const setClientBonusScore = createAction<any>(SET_CLIENT_BONUS_SCORE);

export const fetchClientInfo = createAction<undefined>(FETCH_CLIENT_INFO);
